import { useState, useCallback, createContext, useContext } from 'react';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
    const [token, setToken] = useState(() => localStorage.getItem('token'));
    const [user, setUser] = useState(() => JSON.parse(localStorage.getItem('user') || 'null'));
    const [isSuperAdmin, setIsSuperAdmin] = useState(() => localStorage.getItem('is_superadmin') === 'true');
    const [role, setRole] = useState(() => localStorage.getItem('role') || 'admin');

    const login = useCallback((t, u, superAdmin = false, userRole = 'admin') => {
        localStorage.setItem('token', t);
        localStorage.setItem('user', JSON.stringify(u));
        localStorage.setItem('is_superadmin', superAdmin ? 'true' : 'false');
        localStorage.setItem('role', userRole);
        setToken(t);
        setUser(u);
        setIsSuperAdmin(superAdmin);
        setRole(userRole);
    }, []);

    const logout = useCallback(() => {
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        localStorage.removeItem('is_superadmin');
        localStorage.removeItem('role');
        setToken(null);
        setUser(null);
        setIsSuperAdmin(false);
        setRole('admin');
    }, []);

    const updateUser = useCallback((updates) => {
        setUser(prev => {
            const nu = { ...prev, ...updates };
            localStorage.setItem('user', JSON.stringify(nu));
            return nu;
        });
    }, []);

    const isChatter = role === 'chatter';
    const value = { token, user, login, logout, updateUser, isAuth: !!token, isSuperAdmin, role, isChatter };
    return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}

export function useAuth() {
    return useContext(AuthContext);
}
